module.exports = __webpack_public_path__ + "static/icon_number03-e2a1e1d53475f82f73823c4cfe93e1d2.png";